const COUNT_DAYS_FROM = "COUNTDAYSFROM"
export default class FormuleInterpreter { //TODO
    interprete(text) {

        //return '<table><tr><td>DUPSa</td><td>dupa</td></tr></table>'
        let resx = [...text.matchAll(/~([a-zA-z]+)\(+([^\)]+)\)~/g)]
        resx.forEach(regexArray => {
            if (regexArray[1] == COUNT_DAYS_FROM) {
                text = text.replace(regexArray[0], this.countDaysFrom(regexArray[2]))
            }
        })
        return text
    }

    countDaysFrom(date) {
        let date1 = new Date(date)
        let currentDate = new Date()
        currentDate.setHours(0, 0, 0, 0)
        date1.setHours(0, 0, 0, 0)
        let differenceInTime = currentDate - date1.getTime()
        return Math.round(differenceInTime / (1000 * 3600 * 24))
    }

}